// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.3.6.1@antd/es/_util/interopDefault.js
// module id = 73
// module chunks = 1